import SEO from '@/components/SEO';
import { legal } from '@/data/content';

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Use"
        description="Read the Zuri Hub Terms of Use."
        path="/terms"
      />

      <section className="bg-slate-900 px-4 py-20 text-white sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl">{legal.terms.title}</h1>
          <p className="mt-4 text-slate-300">Last updated: {legal.terms.lastUpdated}</p>
        </div>
      </section>

      <section className="py-16" aria-label="Terms content">
        <div className="prose mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          {legal.terms.sections.map((section) => (
            <div key={section.title} className="mb-10">
              <h2 className="text-2xl font-bold text-slate-900">{section.title}</h2>
              {section.paragraphs.map((p, i) => (
                <p key={i} className="mt-4 leading-relaxed text-slate-600">
                  {p}
                </p>
              ))}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
